<template>
<vs-card class="cardx">
  <div class="div1">
    <div class="btnAdd">
      <vs-button @click="add()" color="darkgreen" type="border" icon="add">Crear Usuario</vs-button>
    </div>
  </div>
  <div class="div2">
    <vs-table :max-items="$store.state.pagination" pagination search :data="users">
      <template slot="thead">
      <vs-th sort-key="name">
          Nombre De Usuario
      </vs-th>
      <vs-th sort-key="email">
          Email
      </vs-th>
      <vs-th>
          Contraseña
      </vs-th>
      <vs-th sort-key="role">
          Rol
      </vs-th>
      <vs-th>
      </vs-th>
      <vs-th>
      </vs-th>
      </template>

      <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].username">
          {{data[indextr].username}}
          </vs-td>
          <vs-td :data="data[indextr].email">
          {{data[indextr].email}}
          </vs-td>
          <vs-td>
          **********
          </vs-td>
          <vs-td :data="data[indextr].role">
          {{data[indextr].role}}
          </vs-td>
          <div>
          <vs-td :data="data[indextr].id">
          <vs-button @click="edit(data[indextr].id)" color="darkgreen" type="border" icon="edit">Editar</vs-button>
          </vs-td>
          <vs-td :data="data[indextr].id">
          <vs-button :disabled="data[indextr].username == 'psinet' && data[indextr].role == 'admin'" @click="del(data[indextr].id)" color="darkgreen" type="border" icon="delete">Borrar</vs-button>
          </vs-td>
          </div>
      </vs-tr>
      </template>
    </vs-table>
    <div>
      <UserModal :show="showModal" @close="showModal = false">
        <template #body>
          <UserEdit v-if="$data.vwEdit" :id="$data.id"></UserEdit>
          <UserAdd v-if="$data.vwAdd"></UserAdd>
        </template>
      </UserModal>
    </div>
</div>
</vs-card>
</template>
<script>
import axios from 'axios'
import UserModal from './components/utils/Modal'
import UserEdit from './components/user/UserEdit.vue'
import UserAdd from './components/user/UserAdd.vue'
export default {
    name: "userRegister",
    props:{
    },
    components: {
    UserModal,
    UserEdit,
    UserAdd

},
    data:()=>({
    users: [],
    showModal: false,
    id: '',
    vwEdit: false,
    vwAdd: false,
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    getUsers(){
      const url_api =  this.$store.state.url_api
      axios.get(url_api + 'api/userList').then(response => {
        this.users = response.data
        this.showA = true
      })
      .catch((error) => {
        console.error(error)
      })
    },
    edit(id){
      this.vwEdit = true
      this.vwAdd = false
      this.showModal = true
      this.id = String(id)
    },
    add(){
      this.vwAdd = true
      this.vwEdit = false
      this.showModal = true
    },
    del(id){
      const url_api =  this.$store.state.url_api
      axios.get(url_api + 'api/userDelete', { params: {user_id:id} }).then(response => {
        this.getUsers()
      })
      .catch((error) => {
        this.error_msg = error.response.data
      })
    },
  },
  mounted(){
  this.getUsers()
  },
  watch: {
    showModal: function(val){
      this.getUsers()
    }
  }
}
</script>
<style>
  .vs-button:hover{
    color: white !important;
    background-color: white;
    border-color: white;
  }
  .div1{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    width: auto;
    height: 50px;
  }

  .btnAdd{
    float: right;
    width: auto;
  }

  .div2{
    margin-top: 20px;
    width: auto;
    height: 200px;
  }
  .vs-table--search-input{
    border: 0.5px solid rgb(43 43 43 / 49%);
    border-radius: 8px;
  }
</style>